import Masonry from 'masonry-layout';
import imagesloaded from 'imagesloaded';

const masonry = {
  containerNodes: null,

  init() {
    this.containerNodes = Array.from(document.querySelectorAll('.js-masonry-container'));

    if (this.containerNodes && this.containerNodes.length > 0) {
      this.containerNodes.forEach((container) => {
        imagesloaded(container, () => {
          const grid = container.querySelector('.js-masonry-grid');
          const loading = container.querySelector('.js-loading');
          const msnry = new Masonry( grid, {
            itemSelector: '.js-masonry-grid-item',
            horizontalOrder: true,
            percentPosition: true,
            initLayout: false,
          });

          grid.classList.remove('hidden');
          loading.classList.remove('is-active');
          msnry.layout();
        });
      });
    }
  },
};

export default masonry;



// WEBPACK FOOTER //
// ./scripts/modules/masonry.js